(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name commons.service:UserPrivilegesService
   *
   * @description
   *
   */
  angular
    .module('commons')
    .service('UserPrivilegesService', UserPrivilegesService);

  function UserPrivilegesService(RemoteService) {
    var self = this, privilegeView, privilegeExeStack={};
    self.privilege = {};

    /**
     *
     * @param view
     */
    self.setUserPrivilegeView = function (view) {
      privilegeView = view;
      setPrivileges()
    };

    /**
     * check the privilege by name
     * @param privilege
     * @returns {boolean}
     */
    self.checkPrivilege = function(privilege){
      var privilegeSet = {}, privilegeStatus = false;
        var _privilegeView = setView(privilegeView);
        if (self.privilege.hasOwnProperty(_privilegeView)) {
          privilegeSet = self.privilege[_privilegeView];
          if (privilegeSet.hasOwnProperty(privilege)) {
            privilegeStatus = privilegeSet[privilege];
          }
        }
      return privilegeStatus;
    };

    /**
     * registering the listener function for the privileges
     * @param privilegeType
     * @param listener
     */
    self.registerPrivilegeExeStack = function(privilegeType, listener){
      privilegeExeStack[privilegeType] ? privilegeExeStack[privilegeType].push(listener) : privilegeExeStack[privilegeType] = [listener];
    };

    /**
     * notify the listener
     */
    self.notifyPrivilegeExeStack = function () {
      angular.forEach(privilegeExeStack, function (listener) {
        angular.forEach(listener, function (listenerFn) {
          listenerFn();
        });
      });
    };

    /**
     * local function to set privileges
     */
    function setPrivileges(){
      var _privilegeView = setView(privilegeView);
      if (!self.privilege.hasOwnProperty(_privilegeView)){
        RemoteService.loadUserPrivileges(privilegeView).then(
          function (response) {
            var findDTO = _privilegeView + "PriviledgesDTO";
            if(response.hasOwnProperty(findDTO)){
              self.privilege[_privilegeView] = response[findDTO];
              self.notifyPrivilegeExeStack();
            }
          },
          function (error) {
          }
        );
      }
    }

    function setView(viewString){
      var strArray = viewString.split("/"),returnStr ='';
      returnStr += strArray[0];
      if (strArray.length>1){
        for (var i=1;i<strArray.length;i++){
          returnStr += strArray[i].charAt(0).toUpperCase() + strArray[i].slice(1);
        }
      }
      return returnStr;
    };

  }
}());
